import React, { useEffect, useState } from 'react';
import api from '../api';

const AdminOrders = () => {
  const [orders, setOrders] = useState([]);
  const [search, setSearch] = useState('');
  const [message, setMessage] = useState('');
  const [sellerQuery, setSellerQuery] = useState('');

  const fetchOrders = async () => {
    try {
      const token = localStorage.getItem('token');
      const res = await api.get(`/admin/orders?seller=${sellerQuery}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setOrders(res.data);
    } catch (err) {
      console.error('Error fetching orders:', err);
      setMessage('Error fetching orders');
    }
  };

  useEffect(() => {
    fetchOrders();
  }, []);

  const handleDelete = async (orderId) => {
    if (!window.confirm('Sei sicuro di voler eliminare questo ordine?')) return;
    try {
      const token = localStorage.getItem('token');
      await api.delete(`admin/orders/${orderId}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      fetchOrders();
    } catch (err) {
      console.error('Errore nella cancellazione:', err);
    }
  };

  const filteredOrders = orders.filter(order =>
    order._id.includes(search) ||
    order.user?.email?.toLowerCase().includes(search.toLowerCase()) ||
    order.orderItems.some(item => item.product?.name?.toLowerCase().includes(search.toLowerCase()))
  );

  return (
    <div className="container mt-5">
      <h2 className="text-success mb-4">Gestione Ordini</h2>

      {/* Ricerca per contenuto generico */}
      <input
        type="text"
        placeholder="Cerca per ID ordine, utente o prodotto"
        className="form-control mb-3"
        value={search}
        onChange={(e) => setSearch(e.target.value)}
      />

      {/* Ricerca per venditore */}
      <div className="input-group mb-4">
        <input
          type="text"
          placeholder="Cerca per venditore"
          className="form-control"
          value={sellerQuery}
          onChange={(e) => setSellerQuery(e.target.value)}
        />
        <button className="btn btn-success" type="button" onClick={fetchOrders}>
          Cerca
        </button>
      </div>

      {message && <div className="alert alert-danger">{message}</div>}

      {filteredOrders.map(order => (
        <div key={order._id} className="card mb-3 shadow-sm">
          <div className="card-body">
            <h5 className="card-title">Ordine #{order._id}</h5>
            <p className="mb-1"><strong>Utente:</strong> {order.user?.email}</p>
            <p className="mb-1"><strong>Stato:</strong> {order.status}</p>
            <p className="mb-1"><strong>Totale:</strong> €{order.totalAmount?.toFixed(2)}</p>

            <ul className="list-group mb-3">
              {order.orderItems.map((item, idx) => (
                <li key={idx} className="list-group-item d-flex justify-content-between">
                  <div>
                    <div><strong>{item.product?.name}</strong> x {item.quantity}</div>
                    {item.product?.seller?.email && (
                      <div className="text-muted small">
                        Venditore: {item.product.seller.email}
                      </div>
                    )}
                  </div>
                  <strong>€{(item.price * item.quantity).toFixed(2)}</strong>
                </li>
              ))}
            </ul>

            <button className="btn btn-danger" onClick={() => handleDelete(order._id)}>
              Elimina Ordine
            </button>
          </div>
        </div>
      ))}
    </div>
  );
};

export default AdminOrders;
